import { VueRenderer } from "@tiptap/vue-3";
import tippy from "tippy.js";

import MentionList from "./MentionList.vue";
import { COACHING_VOCAB } from "./coachingVocab";

/**
 * TipTap suggestion config for the coaching-instructions editor. Triggered by "/",
 * it filters the local whiteboard vocabulary (Lines, Routes, Formations, Players,
 * Backgrounds) so coaches can discover and insert valid tokens as they type.
 * Reuses the shared MentionList.vue dropdown (renders item.name, keyboard nav).
 */
export const coachingSuggestion = {
    char: "/",

    items: ({ query }) => {
        const q = (query || "").toLowerCase();
        const matches = COACHING_VOCAB.filter(
            (v) =>
                v.id.toLowerCase().includes(q) ||
                v.name.toLowerCase().includes(q) ||
                v.group.toLowerCase().includes(q)
        );
        // Empty query -> show a representative slice; otherwise cap the list.
        return matches.slice(0, 12);
    },

    render: () => {
        let component;
        let popup;

        return {
            onStart: (props) => {
                component = new VueRenderer(MentionList, {
                    props,
                    editor: props.editor,
                });

                if (!props.clientRect) {
                    return;
                }

                popup = tippy("body", {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: "manual",
                    placement: "bottom-start",
                });
            },

            onUpdate(props) {
                component.updateProps(props);

                if (!props.clientRect) {
                    return;
                }

                popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                });
            },

            onKeyDown(props) {
                if (props.event.key === "Escape") {
                    popup[0].hide();
                    return true;
                }

                return component.ref?.onKeyDown(props);
            },

            onExit() {
                popup[0].destroy();
                component.destroy();
            },
        };
    },
};
